<!--
 * @Author: Latte
 * @Date: 2021-10-14 14:38:09
 * @LAstEditors: Latte
 * @LastEditTime: 2022-02-28 14:21:42
 * @FilePath: \Siui.Cloud.Medical.Web\src\components\CarouselManagement\MaiLive.vue
-->
<template>
  <!-- 麦粒直播 -->
  <div class="app-container">
    <!-- 顶部栏 -->
    <div class="topbar">
      <div>
        <el-input v-model="searchValue" placeholder="" size="small" prefix-icon="el-icon-search"
                  class="search-input" @keyup.enter.native="search()" clearable/>
        <el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
                   @click.stop="search()">
          搜索
        </el-button>


      </div>
      <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click.stop="handleAdd()"
      >
        新增图片
      </el-button>
    </div>

    <div>
      <el-select v-model="curIsDeletedOption" clearable @change="curSelectOptionChange()">
        <el-option v-for="item in isDeletedOptions" :value="item.value" :label="item.label"
                   :key="item.value"></el-option>
      </el-select>
    </div>

    <!-- 内容 -->
    <el-table
        v-loading="loading"
        :data="tableData"
        :header-cell-style="{ background: '#F5F7FA' }"
        style="width: 100%; margin-bottom: 20px;margin-top: 20px"
        border
    >
      <el-table-column prop="productSlideImageId" label="#" align="center" width="70"></el-table-column>
      <el-table-column prop="title" label="标题" align="center" show-tooltip-when-overflow/>
      <el-table-column prop="createUserID" label="发布人员" align="center" width="150">
        <template #default="scope">
          <user-info :user="scope.row"></user-info>
        </template>
      </el-table-column>
      <el-table-column v-if="userDataType.length > 0" label="所属领域" align="center" width="100">
        <template slot-scope="scope">
          {{ scope.row.userDataType | userDataTypeTransform }}
        </template>
      </el-table-column>
      <el-table-column label="类型" align="center" width="100">
        <template slot-scope="scope">
          {{ scope.row.type | productCarouselTypeTransform }}
        </template>
      </el-table-column>
      <el-table-column label="封面" align="center">
        <template slot-scope="scope">
          <el-image
              style="height: 40px"
              fit="scale-down"
              :src="getImageUrl(scope.row.faceUrl) "
              :preview-src-list="[getImageUrl(scope.row.faceUrl)]"
          />
        </template>
      </el-table-column>
      <el-table-column
          prop="linkUrl"
          label="资源"
          align="center"
          show-tooltip-when-overflow
      >
        <template #default="scope">
          <el-button type="text" @click="handleClickResource(scope.row)">{{ getResourceDesp(scope.row) }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="pageViews" label="浏览量" align="center" width="100"/>
      <el-table-column prop="createTime" label="创建时间" align="center" width="180">
        <template slot-scope="scope">
          {{ scope.row.createTime | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column label="启用状态" align="center" width="180">
        <template #default="scope">
          <el-switch active-text="启用" inactive-text="未启用" :active-value="1" :inactive-value="0"
                     v-model="scope.row.isEnabled"
                     @change="handleSwitch(scope.row)"></el-switch>
        </template>

      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button
              size="small"
              type="primary"
              @click.stop="handleUpdate(scope.$idnex, scope.row)"
          >
            编辑
          </el-button>
          <el-button
              size="small"
              :type="scope.row.isDeleted ? 'warning' : 'danger'"
              @click.stop="handleRemove(scope.row)"
          >
            {{ scope.row.isDeleted ? '恢复' : '删除' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
        v-show="totalCount > pageSize"
        background
        :total="totalCount"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="currentChange"
    />

    <!-- dialogVisible -->
    <el-dialog
        title="添加产品轮播图"
        :visible.sync="dialogVisible"
        width="60%"
    >
      <el-form
          :model="temp"
          ref="productSlideImageForm"
          v-loading="uploadLoading"
      >
        <el-form-item
            label="图片标题"
            prop="title"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-input v-model="temp.title"/>
        </el-form-item>
        <el-form-item label="选择图片">
          <el-upload ref="uploadCoverRef" accept=".png,.jpg" action="" class="upload-demo" :limit="1"
                     :on-change="change2DisplayLocalImage" :auto-upload="false">
            <div style="text-align: left;">
              <el-image style="width: 100px; height: 100px"
                        :src="uploadCoverFile !== null ? uploadCoverFileURL : getImageUrl(temp.faceUrl)"
                        fit="scale-down">
                <template #error>
                  <p></p>
                </template>
              </el-image>
              <br/>
              <el-button size="small" type="primary">点击上传</el-button>
            </div>

            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label-width="90px" label="是否启用">
          <el-switch active-text="启用" inactive-text="未启用" :active-value="1" :inactive-value="0"
                     v-model="temp.isEnabled"></el-switch>
        </el-form-item>
        <el-form-item
            label="类型"
            prop="type"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-select v-model="temp.type" style="width: 100%">
            <el-option label="产品" :value="0"/>
            <el-option label="产品视频" :value="1"/>
            <el-option label="链接" :value="2"/>
          </el-select>
        </el-form-item>
        <el-form-item
            label="绑定ID"
            prop="bindId"
            v-if="temp.type === 0 || temp.type === 1 "
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-input-number v-model="temp.bindId"></el-input-number>
          <div class="el-upload__tip" style="color: #aaa">
            类型为产品时：绑定ID为产品的MachineSeriesID
          </div>
          <div class="el-upload__tip" style="color: #aaa">
            类型为产品视频时：绑定ID为视频videoID
          </div>
        </el-form-item>
        <el-form-item
            v-else
            label="链接地址"
            prop="linkUrl"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-input v-model="temp.linkUrl"></el-input>
        </el-form-item>
        <el-form-item
            v-if="userDataType.length > 0"
            label="所属领域"
            prop="userDataType"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-select v-model="temp.userDataType" style="width: 100%">
            <el-option v-for="item in userDataType" :value="item.value" :key="item.value"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
            size="small"
            :disabled="uploadLoading"
            @click="dialogVisible = false"
        >
          取 消
        </el-button>
        <el-button
            type="primary"
            size="small"
            :disabled="uploadLoading"
            @click="createPicture()"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getProductSliderImageList,
  addProductSliderImage,
  updateProductSliderImage,
  deleteProductSliderImageOrBack
} from "@/api/CarouselManagement/CarouselManagement";
import {getOSSUploadInfo} from "@/api/system/CSDocument/file";
import {getUserType} from "@/utils/userutil";
import UserInfo from "@/components/UserInfo/UserInfo";
import {getCloudUrl, getLocalFileURL} from "@/utils/urlutil";
import {handleRes} from "@/utils/handleRes";
import {isVaild} from "@/utils/validate";
import {uploadFile2OSS} from "@/utils/OSSUpload";
import {deepClone} from "@/utils";
import {copy2Clipboard} from "@/utils/clipboard";
import {go2InstrumentSeries, go2LiveVideoDetail} from "@/utils/UIHelper";
import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";

export default {
  components: {UserInfo},
  data() {
    return {
      navigationKey: "slideImageProduct",

      loading: false, // 加载开关
      searchValue: "",
      uploadLoading: false, // 上传加载开关
      totalCount: 0, // 列表总数
      pageSize: 10, // 单页条数
      currentPage: 1, // 当前页码
      tableData: [],
      dialogVisible: false,
      temp: {userDataType: 0,},
      userDataType: [],
      uploadCoverFile: null,
      uploadCoverFileURL: "",

      curIsDeletedOption: "",
      isDeletedOptions: [
        {
          value: "", label: "全部"
        },
        {
          value: false, label: "未删除"
        },
        {
          value: true, label: "已删除"
        },
      ],
    };
  },
  created() {
    let navigationObj = getNavigationItemObj(this.navigationKey)
    this.searchValue = navigationObj.searchValue
    this.currentPage = navigationObj.currentPage
    this.curIsDeletedOption = navigationObj.curIsDeletedOption
    if (!isVaild(this.curIsDeletedOption)) {
      this.curIsDeletedOption = false;
    }

    this.getProductSlideImageList();
    this.userDataType = getUserType()
  },
  methods: {
    search() {
      this.refreshCurrentList()
    },
    getImageUrl(path) {
      return getCloudUrl(path)
    },
    /**
     * 刷新列表
     */
    refreshCurrentList() {
      this.currentPage = 1
      this.getProductSlideImageList();
    },
    /**
     * 翻页
     *
     * @param {number} currentPage 当前页码
     */
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getProductSlideImageList();
    },
    curSelectOptionChange() {
      this.refreshCurrentList()
    },
    /**
     * 获取直播轮播图
     */
    getProductSlideImageList() {
      this.loading = true;
      const params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        keyWord: this.searchValue,
      };

      if (isVaild(this.curIsDeletedOption)) {
        params.where = [
          {
            "field": "isDeleted",
            "value": this.curIsDeletedOption,
            "op": "equal"
          }
        ]
      }

      setNavigationItemWithObj(this.navigationKey, {
        currentPage: this.currentPage,
        searchValue: this.searchValue,
        curIsDeletedOption: this.curIsDeletedOption
      })
      getProductSliderImageList(params).then((res) => {
        handleRes(res, () => {
          this.totalCount = res.data.total;
          this.tableData = res.data.rows;
        })
        this.loading = false;
      });
    },
    getResourceDesp(entity) {
      let res = ""
      switch (entity.type) {
        case 0:
          res = `产品: ${entity.bindResourceObj?.model}`
          break;
        case 1:
          res = `产品视频： ${entity.bindResourceObj?.videoName}`
          break
        default:
          res = `链接：${entity?.linkUrl}`
      }
      return res
    },
    handleClickResource(entity) {
      switch (entity.type) {
        case 0://产品
          go2InstrumentSeries(this, entity.bindResourceObj?.number)
          break;
        case 1://产品视频
          go2LiveVideoDetail(this, entity?.bindId)
          break
        default:
          copy2Clipboard(entity?.linkUrl)
          this.$message('已复制链接地址')
      }
    },
    /**
     * 启用/停用直播轮播图
     */
    handleSwitch(row) {
      const params = {
        productSlideImageId: row.productSlideImageId,
        isEnabled: row.isEnabled
      };
      updateProductSliderImage(params).then((res) => {
        handleRes(res, () => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.getProductSlideImageList();
        })
      });
    },
    resetTemp() {
      this.temp = {
        userDataType: 0,
      };
    },
    change2DisplayLocalImage(uploadFile) {
      this.$refs.uploadCoverRef.clearFiles();
      this.uploadCoverFile = uploadFile;
      this.uploadCoverFileURL = getLocalFileURL(uploadFile);
    },
    /**
     * @description: 打开添加图片对话框
     * @param {*}
     * @return {*}
     */
    handleAdd() {
      this.resetTemp();
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs["productSlideImageForm"].clearValidate();
      });
    },
    /**
     * @description: 确认添加图片
     * @param {*}
     * @return {*}
     */
    createPicture() {
      this.$refs["productSlideImageForm"].validate(async (valid) => {
        if (valid) {
          this.uploadLoading = true
          let savepathParamsRes = await getOSSUploadInfo({
            DataType: "32",
            ID: "0",
          });
          if (!isVaild(savepathParamsRes)) {
            this.uploadLoading = false
            return;
          }
          let savePathParams = savepathParamsRes.resultData

          //上传封面
          if (isVaild(this.uploadCoverFile)) {
            // printObj(this.uploadCoverFile.raw)
            let timestamp = new Date().valueOf();

            let uploadRes;
            let fileName;
            if (isVaild(this.uploadCoverFile)) {
              fileName = savePathParams.PicSavePath + timestamp + this.uploadCoverFile.name.substring(this.uploadCoverFile.name.lastIndexOf("."));
              // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)
              uploadRes = await uploadFile2OSS(savePathParams, new Blob([this.uploadCoverFile.raw], {
                type: this.uploadCoverFile.raw.type
              }), fileName)
            }
            if (uploadRes.status === 0) {
              this.temp.faceUrl = "/" + fileName
              // console.log(this.form.liveCover)
            } else {
              this.$message({
                type: "error",
                message: "上传失败"
              })
            }
            this.$refs.uploadCoverRef.clearFiles();
          }

          const params = deepClone(this.temp);
          addProductSliderImage(params).then((res) => {
            handleRes(res, () => {
              this.refreshCurrentList()
            })
            this.dialogVisible = false
            this.uploadLoading = false
          });
        } else {
          this.$message({
            type: "error",
            message: "请完善数据",
          });
        }
      });
    },
    /**
     * @description: 打开更新直播轮播对话框
     * @param {*} index
     * @param {*} row
     * @return {*}
     */
    handleUpdate(index, row) {
      this.$router.push({
        path: "productSliderImageDetail",
        query: {
          productSlideImageId: row.productSlideImageId
        }
      })
    },
    /**
     *
     */
    handleRemove(row) {
      let tips = row.isDeleted ? '恢复' : '删除'
      this.$confirm(`是否${tips}该轮播图`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
          .then(() => {
            const params = {
              productSlideImageId: row.productSlideImageId,
            };
            deleteProductSliderImageOrBack(params).then((res) => {
              handleRes(res, () => {
                this.$message({
                  type: "success",
                  message: `${tips}成功`,
                });
                this.getProductSlideImageList();
              })
            });
          })
          .catch(() => {
            this.$message("取消操作");
          });
    },
  },
};
</script>

<style scoped lang="scss">
.el-form-item {
  margin-bottom: 10px;
}
</style>